/*
Copyright 2025 iodyne.  All rights reserved.
iodyne Proprietary/Confidental: INTERNAL USE ONLY
*/

import ProjectListTable from '@/components/controllers/projects/project_list/ProjectListTable';
import { useTranslation } from '@/i18n/client_hook';
import { defaultNS } from '@/i18n/settings';

import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/projects/")({
  component: RouteComponent
})

function RouteComponent() {
  const {t} = useTranslation(defaultNS);

  return <div className="flex flex-col p-6 pt-0">
    <ProjectListTable />
  </div>
}